import { tWithKeyAttr as t } from "../../../i18nHelper";
import popupStyles from "./errorPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";

function GeneralErrorPopup({
  onClose,
  text,
}: IPopupWithoutProps & { text?: string }) {
  return (
    <article className={popupStyles.popup} data-testid="availability-error-popup">
      <h2 className={popupStyles.popup__title}>
        {text || t("ERROR_POPUP_DEFAULT_TEXT")}      </h2>
      <img
        src={doctor}
        alt={t("IMAGE_ALT_VENCHY_DOCTOR")}
        className={popupStyles.popup__img}
      />
      <button
        className={`button hover ${popupStyles.popup__nextBtn}`}
        onClick={onClose}
        data-testid="confirm-error-button"
      >
        {t("ERROR_POPUP_CONFIRM_BUTTON")}
      </button>
    </article>
  );
}

export default GeneralErrorPopup;
